import axios from "axios";
import { API_BASE_URL } from "../common/config.js";

const register = (username, email, password) => {
  return axios.post(API_BASE_URL + "/register", {
    username,
    email,
    password,
  });
};

const setLocalStorage = (token) => {
  localStorage.setItem("user", parseJwt(token));
  localStorage.setItem("userTTL", new Date().getTime() + 24 * 60 * 60 * 1000);
  localStorage.setItem("userToken", token);
};

 // decode the logged in user
 const parseJwt = (token) => {
  if (!token) {
    return;
  }
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  return window.atob(base64);
};


const login = (email, password, twoFactorToken) => {
  return axios
    .post(API_BASE_URL + "/api/auth/login", {
      email,
      password,
      twoFactorToken,
    })
    .then((response) => {
      if (response.data.redirect) {
        const env = response.data.target.split("https://")[1]?.split(".")[0];

        localStorage.setItem('preferredEnvironment', env);
        window.location.href = response.data.target;
        return Promise.reject("Redirecting to the correct environment.");
      }

      if (response.data.token) {
        setLocalStorage(response.data.token);
      }

      return response.data;
    });
};

const autoLogin = (autoLoginToken) => {
  return axios
    .post(API_BASE_URL + "/api/auth/auto-login", { autoLoginToken })
    .then((response) => {
      if (response.data.token) {
        setLocalStorage(response);
      }
      return response.data;
    });
};


const clearLocalStorage = () => {
  // remove all items from localStorage except for language
  const languageValue = localStorage.getItem('language');
  const preferredEnvironment = localStorage.getItem('preferredEnvironment');

  // Clear all items
  localStorage.clear();

  // Restore the 'language' item, if it existed
  if (languageValue !== null) {
      localStorage.setItem('language', languageValue);
  }

  // Restore the 'preferredEnvironment' item, if it existed
  if (preferredEnvironment !== null) {
      localStorage.setItem('preferredEnvironment', preferredEnvironment);
  }
};

const logout = () => {
  clearLocalStorage();
  window.location.reload();
};

const getCurrentUser = () => {
  if (localStorage.getItem("user") && localStorage.getItem("userTTL") && parseInt(localStorage.getItem("userTTL")) > new Date().getTime()) {
    let user = JSON.parse(localStorage.getItem("user"));

    if(localStorage.getItem("currentProject")) {
      const project = JSON.parse(localStorage.getItem("currentProject"));
      user.selectedProject = project;
    }

    if(localStorage.getItem("currentOrg")) {
      const org = JSON.parse(localStorage.getItem("currentOrg"));
      user.selectedOrg = org;
    }

    return user;
  }
  else {
    clearLocalStorage();
    return false;
  }
};

const setPassword = async (userId, token, password) => {
  const response = await axios
    .post(API_BASE_URL + "/api/users/set-password", {
      userId,
      token,
      password,
      language: localStorage.getItem('language') || undefined,
    });

  return response;
};

const forgotPassword = async (email, language = 'en') => {
  const response = await axios
    .post(API_BASE_URL + "/api/users/forgot-password", {
      email,
      language
    });

  return response;
};

const resetPassword = async (userId, token, password) => {
  const response = await axios
    .post(API_BASE_URL + "/api/users/reset-password", {
      userId,
      token,
      password,
    });

  return response;
};

const getRequestData = async (reqId, token) => {
  const response = await axios.get(
    API_BASE_URL + `/api/requests/${reqId}/${token}`
  );
  return response.data;
};

const createTrialEnvironment = async (reqId, token, name, password, orgName, projectName) => {
  const response = await axios
    .post(API_BASE_URL + "/api/requests/create-trial-environment", {
      reqId,
      token,
      name,
      password,
      orgName,
      projectName,
      language: localStorage.getItem('language') ? localStorage.getItem('language') : null
    });

  return response;
};

const microsoftLogin = async (accessToken) => {
  return axios
    .post(API_BASE_URL + "/api/auth/microsoft-login", {
      accessToken,
    })
    .then((response) => {
      if (response.data.redirect) {
        const env = response.data.target.split("https://")[1]?.split(".")[0];
        localStorage.setItem('preferredEnvironment', env);
        window.location.href = response.data.target;
        return Promise.reject("Redirecting to the correct environment.");
      }

      if (response.data.token) {
        setLocalStorage(response);
      }

      return response.data;
    });
};

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
  setPassword,
  forgotPassword,
  resetPassword,
  getRequestData,
  createTrialEnvironment,
  autoLogin,
  microsoftLogin,
  setLocalStorage
};

export default AuthService;
